import { createSelector } from 'reselect';
import { AppState } from '../types/store';

export const getSlice = (state: AppState) => state.studio?.earnings;

export const getAvailableBalance = createSelector(
  [getSlice],
  earnings => earnings?.availableBalance
);

export const getPendingTransactions = createSelector(
  [getSlice],
  earnings => earnings?.pendingTransactions
);

export const getTotalWithdrawn = createSelector(
  [getSlice],
  earnings => earnings?.totalWithdrawn
);

export const getPaypalInfo = createSelector(
  [getSlice],
  earnings => earnings?.paypal
);

export const getPaypalEmail = createSelector(
  [getPaypalInfo],
  paypal => paypal?.email
);

export const getPaypalIsMissingCountry = createSelector(
  [getPaypalInfo],
  paypal => paypal?.isMissingCountry
);

export const getPaypalMinimumWithdrawalAmount = createSelector(
  [getPaypalInfo],
  paypal => paypal?.minimumWithdrawalAmount
);

export const getPaypalFee = createSelector(
  [getPaypalInfo],
  paypal => paypal?.fee
);

export const getBitpayInfo = createSelector(
  [getSlice],
  earnings => earnings?.bitpay
);

export const getBitpayEmail = createSelector(
  [getBitpayInfo],
  bitpay => bitpay?.email
);

export const getBitpayMinimumWithdrawalAmount = createSelector(
  [getBitpayInfo],
  bitpay => bitpay?.minimumWithdrawalAmount
);

export const getBitpayFee = createSelector(
  [getBitpayInfo],
  bitpay => bitpay?.fee
);

export const getStripeInfo = createSelector(
  [getSlice],
  earnings => earnings?.stripe
);

export const getStripeStatus = createSelector(
  [getStripeInfo],
  stripe => stripe?.status
);

export const getStripeMinimumWithdrawalAmount = createSelector(
  [getStripeInfo],
  stripe => stripe?.minimumWithdrawalAmount
);

export const getStripeFee = createSelector(
  [getStripeInfo],
  stripe => stripe?.fee
);

export const getIsTwofactorRequired = createSelector(
  [getSlice],
  earnings => earnings?.isTwofactorRequired
);

export const getIsWithdrawalSuspended = createSelector(
  [getSlice],
  earnings => earnings?.isWithdrawalSuspended
);
